<div class="position-attachments">

    <div *ngIf="!isConfirmed" class="icc-card" >

        <span class="icc-card__label">{{ 'INTERFACE|Dodaj załącznik' | translate }}</span>

        <div class="file-picker">
            <input
                type="file"
                multiple
                accept="application/pdf, image/jpeg, image/png, application/msword"
                value=""
                (change)="addAttachment($event.target)"
            ><br>
            <small>{{ 'INTERFACE|Akceptowane pliki to pdf, doc, docx, jpg i png.' | translate }}</small>
        </div>

    </div>

    <div *ngFor="let attachment of attachments" class="icc-card">

        <span class="icc-card__label attachment-label" (click)="downloadAttachment(attachment)" *ngIf="attachment.data">
            {{attachment.name}}
        </span>

        <a class="icc-card__label attachment-label" [href]="'/attachments/' + attachment.uuid" [download]="attachment.name"  *ngIf="!attachment.data">
            {{attachment.name}}
        </a>

        <button *ngIf="!isConfirmed" mat-icon-button (click)="removeAttachment(attachment)" [title]="'INTERFACE|Usuń' | translate">
            <icc-icon name="delete"></icc-icon>
        </button>

    </div>

</div>
